/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { Plus, RemindFill, Search } from '@rsuite/icons';

import {
  Table,
  Input,
  InputGroup,
  Button,
  FlexboxGrid,
  Modal,
  Form,
  IconButton,
  Schema,
  SelectPicker,
} from 'rsuite';
import { useDebouncedCallback } from 'use-debounce/lib';
import { toast } from 'react-toastify';
import { Container } from '~/styles/tabela';
import api from '~/services/api';
import { CelulaEditavel } from '~/components/Celulas/components/CelulaEditavel';
import { TabelaSemPaginacao } from '~/components/TabelaSemPaginacao';
import { Editor } from '@tinymce/tinymce-react';
import { ButtonFullBlue } from '../../../components/Buttons/ButtonFullBlue/styles';
import { ResponsiveFormTextArea } from '../../../components/ResponsiveForm';
import { CelulaAcaoHabilidade } from './components/CelulaEditavel';
import PageHeader from '../../../components/PageHeader';
import Card from '../../../components/Card';

const { HeaderCell, Column, Cell } = Table;

const { StringType } = Schema.Types;

const modelo = Schema.Model({
  titulo: StringType().isRequired(
    'Título do modelo de email obrigatório.'
  ),
  corpo: StringType().isRequired(
    'Corpo do modelo de email obrigatório.'
  ),
});

function ModelosEmail() {
  const [dados, setDados] = useState({
    listaInicial: [],
    modeloLista: [],
    modeloListaFiltrada: [],
    filtro: '',
  });
  const [apagarModeloDialog, setApagarModeloDialog] = useState({
    exibir: false,
    modelo: {},
  });
  const [editarModeloDialog, setEditarModeloDialog] = useState({
    exibir: false,
    modelo: {},
  });
  const [carregando, setCarregando] = useState(true);
  const [adicionarModeloDialog, setModeloDialog] = useState(false);
  const [camposInput, setCamposInput] = useState({});
  const [tituloSelecionado, setTituloSelecionado] = useState('');
  const [editorContent, setEditorContent] = useState('');
  const editorRef = React.useRef(null);

  async function buscarModelos() {
    try {
      const paramsBusca = {
        titulo: tituloSelecionado,
      };
      const resposta = await api.get('/modelos-email', {
        params: paramsBusca,
      });
      const lista = resposta.data.map((item) => ({
        ...item,
      }));
      setDados({
        listaInicial: resposta.data,
        modeloLista: lista,
        modeloListaFiltrada: lista,
      });
      setCarregando(false);
    } catch (e) {
      setCarregando(false);
      toast.error(e.message);
    }
  }

  useEffect(() => {
    buscarModelos();
  }, [tituloSelecionado]);

  useEffect(() => {
    if (editarModeloDialog.exibir) {
      setEditorContent(editarModeloDialog.modelo.corpo || '');
      setCamposInput({
        titulo: editarModeloDialog.modelo.titulo || '',
        corpo: editarModeloDialog.modelo.corpo || '',
      });
    }
  }, [editarModeloDialog]);

  function abrirApagarDialog(item) {
    setApagarModeloDialog({
      exibir: true,
      modelo: item,
    });
  }

  function fecharApagarDialog() {
    setApagarModeloDialog({
      exibir: false,
      modelo: {},
    });
  }

  function abrirEditarDialog(item) {
    setEditarModeloDialog({
      exibir: true,
      modelo: item,
    });
  }

  function fecharEditarDialog() {
    setEditarModeloDialog({
      exibir: false,
      modelo: {},
    });
  }

  async function excluirModelo() {
    try {
      await api.delete(
        `/modelos-email/${apagarModeloDialog.modelo.id}`
      );
      toast.success('Modelo de email excluído com sucesso');
      fecharApagarDialog();
      buscarModelos();
    } catch (e) {
      toast.error(e.message);
    }
  }

  async function adicionarModeloEmail() {
    try {
      setCarregando(true);
      await api.post(`/modelos-email`, {
        titulo: camposInput.titulo,
        corpo: camposInput.corpo,
      });
      toast.success('Modelo de email adicionado com sucesso');
      setCarregando(false);
      setModeloDialog(false);
      buscarModelos();
      setEditorContent('');
      if (editorRef.current) editorRef.current.setContent('');
    } catch (e) {
      toast.error(e.message);
    }
  }

  async function editarModelo() {
    const newModelo = {
      titulo: camposInput.titulo,
      corpo: camposInput.corpo,
    };
    try {
      setCarregando(true);
      await api.put(
        `/modelos-email/${editarModeloDialog.modelo.id}`,
        newModelo
      );
      toast.success('Modelo de email editado com sucesso');
      setCarregando(false);
      buscarModelos();
      fecharEditarDialog();
      setEditorContent('');
      if (editorRef.current) editorRef.current.setContent('');
    } catch (e) {
      toast.error(e.message);
    }
  }

  function alterarTextoCelula(id, key, value) {
    const novaLista = Object.assign([], dados.modeloLista);
    novaLista.find((item) => item.id === id)[key] = value;
    setDados({ ...dados, modeloLista: novaLista });
  }

  // Handler para abrir o modal de adicionar
  const handleOpenAdicionar = () => {
    setModeloDialog(true);
    setEditorContent('');
    setCamposInput({ titulo: '', corpo: '' });
  };

  return (
    <Container>
      <PageHeader
        title="Modelos de Email"
        subtitle="Gerencie os modelos de email disponíveis no sistema."
        actions={
          <Button
            appearance="primary"
            startIcon={<Plus />}
            onClick={() => handleOpenAdicionar(true)}
          >
            Adicionar Modelo de Email
          </Button>
        }
      />
      <Card>
        <InputGroup style={{ width: '300px' }}>
          <Input
            name="titulo"
            style={{ width: '180px' }}
            placeholder="Buscar por título"
            onChange={
              useDebouncedCallback(setTituloSelecionado, 500).callback
            }
            onFocus={() => setTituloSelecionado('')}
          />
          <InputGroup.Button>
            <Search />
          </InputGroup.Button>
        </InputGroup>

        <TabelaSemPaginacao
          carregando={carregando}
          dados={dados.modeloListaFiltrada}
        >
          <Column resizable width={200}>
            <HeaderCell>Ações</HeaderCell>
            <CelulaAcaoHabilidade
              dataKey="id"
              onClick={abrirEditarDialog}
              onDelete={abrirApagarDialog}
            />
          </Column>
          <Column resizable width={300} sortable>
            <HeaderCell>Título</HeaderCell>
            <CelulaEditavel dataKey="titulo" onChange={alterarTextoCelula} />
          </Column>

          <Column resizable width={500} sortable>
            <HeaderCell>Corpo</HeaderCell>
            <Cell dataKey="corpo" />
          </Column>

        </TabelaSemPaginacao>
      </Card>

      <Modal
        backdrop="static"
        open={adicionarModeloDialog}
        onClose={() => setModeloDialog(false)}
        size="md"
      >
        <Form
          model={modelo}
          onChange={setCamposInput}
          onSubmit={(status) => status && adicionarModeloEmail()}
          formValue={camposInput}
        >
          <Modal.Header>
            <h3>Adicionar Modelo de Email</h3>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.ControlLabel>Título</Form.ControlLabel>
              <Form.Control name="titulo" />
            </Form.Group>

            <Form.Group>
              <Form.ControlLabel>Corpo do Email</Form.ControlLabel>
              <Editor
                onInit={(evt, editor) => { editorRef.current = editor; }}
                apiKey="pv8hnike17xcj19zp9782tyg170swsns0wxumltslkzn2j8d"
                init={{
                  menubar: 'custom',
                  plugins: ['emoticons', 'link'],
                  height: 300,
                  language: 'pt_BR',
                  language_url: '/tiny_lang/pt_BR.js',
                  toolbar: 'emoticons | bold italic underline strikethrough | fontsizeselect | link',
                  fontsize_formats: '16px 22px 26px',
                  content_style: `body {text-align: left;}`,
                  preview_styles: 'background-color',
                  required: true,
                  placeholder: 'Limite de 500 caracteres',
                }}
                value={editorContent}
                onEditorChange={(content, editor) => {
                  if (editor.getContent({ format: 'text' }).length <= 500) {
                    setEditorContent(content);
                    setCamposInput((prev) => ({ ...prev, corpo: content }));
                  } else {
                    editor.setContent(editorContent);
                  }
                }}
              />
              <p>
                Caracteres disponíveis:{' '}
                {editorContent !== ''
                  ? 500 - (editorRef.current?.getContent({ format: 'text' }).length || 0)
                  : 500}
              </p>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              onClick={() => setModeloDialog(false)}
              appearance="subtle"
            >
              Cancelar
            </Button>
            <ButtonFullBlue type="submit" appearance="primary">
              Adicionar
            </ButtonFullBlue>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        backdrop="static"
        open={editarModeloDialog.exibir}
        onClose={fecharEditarDialog}
        size="md"
      >
        <Form
          model={modelo}
          onChange={setCamposInput}
          onSubmit={(status) => status && editarModelo()}
          formValue={camposInput}
        >
          <Modal.Header>
            <h3>Editar Modelo de Email</h3>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.ControlLabel>Título</Form.ControlLabel>
              <Form.Control
                name="titulo"
                defaultValue={
                  editarModeloDialog.modelo.titulo || ''
                }
              />
            </Form.Group>

            <Form.Group>
              <Form.ControlLabel>Corpo do Email</Form.ControlLabel>
              <Editor
                onInit={(evt, editor) => { editorRef.current = editor; }}
                apiKey="pv8hnike17xcj19zp9782tyg170swsns0wxumltslkzn2j8d"
                init={{
                  menubar: 'custom',
                  plugins: ['emoticons', 'link'],
                  height: 300,
                  language: 'pt_BR',
                  language_url: '/tiny_lang/pt_BR.js',
                  toolbar: 'emoticons | bold italic underline strikethrough | fontsizeselect | link',
                  fontsize_formats: '16px 22px 26px',
                  content_style: `body {text-align: left;}`,
                  preview_styles: 'background-color',
                  required: true,
                  placeholder: 'Limite de 500 caracteres',
                }}
                value={editorContent}
                onEditorChange={(content, editor) => {
                  if (editor.getContent({ format: 'text' }).length <= 500) {
                    setEditorContent(content);
                    setCamposInput((prev) => ({ ...prev, corpo: content }));
                  } else {
                    editor.setContent(editorContent);
                  }
                }}
              />
              <p>
                Caracteres disponíveis:{' '}
                {editorContent !== ''
                  ? 500 - (editorRef.current?.getContent({ format: 'text' }).length || 0)
                  : 500}
              </p>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={fecharEditarDialog} appearance="subtle">
              Cancelar
            </Button>
            <ButtonFullBlue type="submit" appearance="primary">
              Editar
            </ButtonFullBlue>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        backdrop="static"
        open={apagarModeloDialog.exibir}
        onClose={fecharApagarDialog}
        size="xs"
      >
        <Modal.Header>
          <h3>Apagar Modelo de Email</h3>
        </Modal.Header>
        <Modal.Body>
          Você realmente deseja apagar este modelo de email? <br /> <br />
          id: {apagarModeloDialog.modelo.id} <br />
          título: {apagarModeloDialog.modelo.titulo} <br />
          Essa ação é irreversível{' '}
          <RemindFill
            style={{
              color: '#ffb300',
              fontSize: 24,
            }}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={fecharApagarDialog} appearance="subtle">
            Cancelar
          </Button>
          <ButtonFullBlue onClick={() => excluirModelo()} appearance="primary">
            Deletar
          </ButtonFullBlue>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ModelosEmail;
